import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop, Ref, Watch } from 'vue-property-decorator';
import { useStepper } from '@/hook/useStepper';
import type { Account, Channel, ScrapAgentRegisterRequest } from '@/shared/model/scrap-agent.model';
import { ScrapeBriefingRequest } from '@/shared/model/scrap-agent.model';
import ScrapAgentService from '@/service/scrap-agent.service';
import ScrapAgentStep3 from '@/entities/scrap-agent/modal-step/modal-step3/step3.vue';
import ScrapAgentStep2 from '@/entities/scrap-agent/modal-step/modal-step2/step2.vue';
import ScrapAgentStep1 from '@/entities/scrap-agent/modal-step/modal-step1/step1.vue';
import DsModal from '@/shared/modal/ds-modal.vue';
import ScrapAgentModalStep2Login from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/modal-step2-login.vue';
import * as events from 'events';
import ScrapAgentModalStep2Access from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/modal-step2-access.vue';
import ScrapAgentStep2Account from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/step2-account.vue';
import ScrapAgentModalChannelRegister from '@/entities/scrap-agent/modal-channel-register/modal-channel-register.vue';
import ScrapAgentModalChannelRegisterUrlForm from '@/entities/scrap-agent/account/account-connect/connect-url/modal-channel-register-url-form.vue';

import ScrapAgentAccountOneOneDriver from '@/entities/scrap-agent/account/account-connect/connect-cloud/connect-driver/account-connect-driver.vue';
import ScrapAgentAccountRSS from '@/entities/scrap-agent/account/account-connect/connect-rss/account-connect-rss.vue';
import ScrapAgentAccountConnectLoading from '@/entities/scrap-agent/account/account-connect-loading/scrap-agent-account-connect-loading.vue';
import ScrapAgentMetaSearch from '@/entities/scrap-agent/account/account-connect/connect-metasearch/account-connect-metasearch.vue';
import ScrapAgentAccountConnectOneDriver from '@/entities/scrap-agent/account/account-connect/connect-cloud/connect-oneDrive/account-connect-oneDriver.vue';
import scrapAgentAccountConnectDropbox from '@/entities/scrap-agent/account/account-connect/connect-cloud/connect-dropBox/account-connect-dropbox.vue';

import ScrapAgentConnectYoutube from '@/entities/scrap-agent/account/account-connect/connect-social/connect-youtube/connect-youtube.vue';
import ScrapAgentAccountConnectYoutube from '@/entities/scrap-agent/account/account-connect/connect-social/connect-youtube/youtube-sign-in/youtube-account/account-connect-youtube.vue';
import ScrapAgentAccountConnectYoutubeLogin from '@/entities/scrap-agent/account/account-connect/connect-social/connect-youtube/youtube-sign-in/youtube-login/scrap-agent-account-connect-youtube-login.vue';

import ScrapAgentConnectTweeter from '@/entities/scrap-agent/account/account-connect/connect-social/connect-twitter/scrap-agent-account-connect-tweeter.vue';
import AccountTwitterLogin from '@/entities/scrap-agent/account/account-connect/connect-social/connect-twitter/twitter-login/account-twitter-login.vue';
import AccountTwitterMode from '@/entities/scrap-agent/account/account-connect/connect-social/connect-twitter/account-twitter-mode/account-twitter-mode.vue';
import ScrapAgentConnectFacebook from '@/entities/scrap-agent/account/account-connect/connect-social/connect-facebook/scrap-agent-account-connect-facebook.vue';
import ScrapAgentFacebookLogin from '@/entities/scrap-agent/account/account-connect/connect-social/connect-facebook/facebook-sign-in/scrap-agent-facebook-login/scrap-agent-account-login-facebook.vue';
import ScrapAgentFacebookAccount from '@/entities/scrap-agent/account/account-connect/connect-social/connect-facebook/facebook-sign-in/scrap-agent-facebook-account/scrap-agent-account-connect-facebook.vue';
import ScrapAgentConnectReddit from '@/entities/scrap-agent/account/account-connect/connect-social/connect-reddit/scrap-agent-account-connect-reddit.vue';
import ScrapAgentConnectEmail from '@/entities/scrap-agent/account/account-connect/connect-mail/step2-account-mail.vue';
import ScrapAgentRedditLogin from '@/entities/scrap-agent/account/account-connect/connect-social/connect-reddit/scrap-agent-reddit-login/scrap-agent-reddit-login.vue';
import ScrapAgentAccountLoginMail from '@/entities/scrap-agent/account/account-connect/connect-mail/mail-sign-in/scrap-agent-mail-login/account-login-mail.vue';
import ScrapAgentRedditAccount from '@/entities/scrap-agent/account/account-connect/connect-social/connect-reddit/scrap-agent-reddit-account/scrap-agent-reddit-login.vue';
import { namespace } from 'vuex-class';
import ScrapAgentEmailAccount from '@/entities/scrap-agent/account/account-connect/connect-mail/mail-sign-in/mail-account/account-connect-mail.vue';
import WebsocketService from '@/service/websocket.service';
import AccountNaverBlogMode from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/connect-naver-blog/account-naver-blog-mode.vue';
import AccountBrunchMode from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/connect-brunch/account-brunch-mode.vue';
import AccountConnectLoginCloud from '@/entities/scrap-agent/account/account-connect/connect-cloud/connect-login-cloud/account-connect-login-cloud.vue';
import AccountMediumMode from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/connect-medium/account-medium-mode.vue';
import AccountWordpressLogin from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/connect-wordpress/account-wordpress-login.vue';
import AccountWordpressMode from '@/entities/scrap-agent/account/account-connect/scrap-agent-connect-blog/connect-wordpress/account-wordpress-mode.vue';
import ChannelRegisterCommon from '@/entities/scrap-agent/channel-register-common/channel-register-common.vue';
import VueCustomScrollbar from 'vue-custom-scrollbar/src/vue-scrollbar.vue';
import BriefingService from '@/service/briefing.service';
import ModalStep3Component from '@/entities/scrap-agent/modal-step/modal-step3/modal-step3.vue';
import ModalAccessComponent from '@/entities/scrap-agent/channel-register-common/modal-access.vue';
import { formattedDate } from '../article-detail/artical-common';
import { makeReportTypeText } from '../../util/common-util';
import { formatDateAgo } from '../../util/date-util';
import moment from 'moment';
import ChannelModeModal from '@/shared/modal/collection-channel/channel-mode-modal/channel-mode-modal.vue';
import type { AccountChannel, AgentChannel, ChannelDataSource } from '@/shared/model/collection-channel.model';
import { CHANNEL_DATASOURCE_TYPE, DATA_FILE_TYPE } from '@/constants';
import { ChannelDatasourceProps } from '@/shared/modal/collection-channel/channel-mode-modal/channel-datasource-field/channel-datasource-field.component';
import { isEmptyArray } from '@/util/array-util';

const appStoreState = namespace('appStore');

@Component({
  methods: { formatDateAgo, makeReportTypeText, formattedDate },
  computed: {
    events() {
      return events;
    },
    moment() {
      return moment;
    },
  },
  components: {
    ModalAccessComponent,
    AccountConnectLoginCloud,
    ScrapAgentConnectFacebook,
    ScrapAgentFacebookLogin,
    ScrapAgentFacebookAccount,
    ScrapAgentConnectTweeter,
    AccountTwitterLogin,
    AccountTwitterMode,
    ScrapAgentConnectReddit,
    ScrapAgentRedditLogin,
    ScrapAgentRedditAccount,
    ScrapAgentConnectEmail,
    ScrapAgentMetaSearch,
    ScrapAgentEmailLogin: ScrapAgentAccountLoginMail,
    ScrapAgentEmailAccount,
    ScrapAgentConnectYoutube,
    ScrapAgentAccountConnectYoutube,
    ScrapAgentAccountConnectYoutubeLogin,
    scrapAgentAccountConnectDropbox,
    ScrapAgentAccountConnectOneDriver,
    ScrapAgentAccountConnectLoading,
    ScrapAgentAccountRSS,
    ScrapAgentAccountOneOneDriver,
    ScrapAgentModalChannelRegisterUrlForm,
    ScrapAgentModalChannelRegister,
    ScrapAgentStep2Account,
    ScrapAgentModalStep2Access,
    ScrapAgentModalStep2Login,
    VueCustomScrollbar,
    DsModal,
    ScrapAgentStep1,
    ScrapAgentStep2,
    ScrapAgentStep3,
    AccountNaverBlogMode,
    AccountBrunchMode,
    AccountMediumMode,
    AccountWordpressLogin,
    AccountWordpressMode,
    ChannelRegisterCommon,
    ModalStep3Component,
    ChannelModeModal,
  },
})
export default class ScrapAgentModal extends Vue {
  @Prop({ type: Boolean, required: true }) openScrap!: boolean;
  @Prop({ type: Boolean, default: false }) isShowTab!: boolean;
  @Prop({ type: Object, required: false }) itemSetting!: any;

  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (payload: boolean) => void;

  @Inject('websocketService')
  public websocketService: () => WebsocketService;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @appStoreState.Getter
  public isShowCreateBriefing!: boolean;

  stepper = useStepper(['Agent settings', 'Register collection channel', 'Agent creation complete'], 'Agent settings');
  isModalOpen = this.openScrap;
  isOpenRegister = false;
  isShowStep2Login = false;
  isShowModalStep2Access = false;
  isShowModalStep2Account = false;
  isShowModalRegisterFormUrl = false;
  isRefresh = false;
  formData = {
    requestId: new Date().getTime().toString(),
    userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
    briefingTitle: '',
    briefingDescription: '',
    briefingPrivacy: 'PRIVATE',
    language: this.$store.getters.currentLanguage,
    dataSourceAccount: [] as any,
  } as any;

  @Ref() readonly scrollContainer!: HTMLElement;
  page = 0;
  limit = 10;
  isLoading = false;

  listChannelWithAccount: AccountChannel[] = [];
  sourceCacheList: Channel[] = [];
  listChannel: Channel[] = [];
  categoryType = 'ALL';
  channelConnect: Channel = {} as Channel;
  accountItem: Account = {} as Account;
  highLightAccount = '';
  validBriefingTitle = false;
  userEdit: Account = {} as Account;
  isCheckCreateAccount = false;
  isShowAccessComponent = false;
  isShowRegisterScrapAgentDrive = false;
  isShowRegisterScrapAgentRss = false;
  isShowRegisterScrapAgentBoxDrive = false;
  isShowRegisterScrapAgentOneDrive = false;
  isShowConnectFacebook = false;
  isShowFacebookLogin = false;
  isShowFacebookAccount = false;
  isShowConnectTweeter = false;
  isShowTwitterLogin = false;
  isShowTwitterMode = false;
  isShowConnectReddit = false;
  isShowRedditLogin = false;
  isShowRedditAccount = false;
  isShowConnectEmail = false;
  isShowEmailLogin = false;
  isShowEmailAccount = false;
  isShowConnectYoutube = false;
  isShowAccountConnectYoutube = false;
  isShowAccountConnectYoutubeLogin = false;
  isShowAccountNaverBlogMode = false;
  isShowAccountBrunchMode = false;
  isShowAccountMediumMode = false;
  isShowAccountWordpressLogin = false;
  isShowAccountWordpressMode = false;
  isShowAccountConnectCloudLogin = false;
  isShowScrapAgentMetaSearch = false;
  isShowCreateScrapAgentEnd = false;
  typeEmail = 'GMAIL';
  accountNameSettingModalLogin = null as string;
  accountNameUpdateModalLogin = null as string;
  listAgent: string[] = [];
  charNumberBriefingTitle = 0;
  itemDelete = null;
  itemCreateScrapAgent = null;
  isShowChannelSetting = false;
  state = {
    itemChannelSetting: {
      accountChannel: null as AccountChannel | null,
      agentChannel: null as AgentChannel | null,
      bpId: null,
      datasource: [],
      channelImageUri: null,
      channelName: null,
      channelType: null,
    },
  };
  dataSourceSetting: AccountChannel[] = [];
  loadingRegisterChannel = true;
  scrapAgentDataList = [];
  connectScrapAgentList = [];
  isLoadingGetScrapAgentDataList = true;

  // function......................................................................................................
  get current() {
    return this.stepper.current;
  }

  get isCheckNextStep(): boolean {
    return this.validBriefingTitle === false || !this.formData?.briefingTitle;
  }

  @Watch('formData', { deep: true })
  checkValid(value: ScrapAgentRegisterRequest) {
    const title = value.briefingTitle;
    this.charNumberBriefingTitle = title ? title.length : 0;
    if (title && this.listAgent.includes(title)) {
      this.validBriefingTitle = true;
    } else {
      this.validBriefingTitle = false;
    }
    this.$emit('changeFormData', this.formData);
  }

  @Watch('listAgent', { deep: true })
  checkValidListAgent(value: any) {
    const title = this.formData.briefingTitle;
    this.charNumberBriefingTitle = title ? title.length : 0;
    if (title && value.includes(title)) {
      this.validBriefingTitle = true;
    } else {
      this.validBriefingTitle = false;
    }
    this.$emit('changeFormData', this.formData);
  }

  @Watch('highLightAccount', { deep: true })
  async onHighlightAccount(value: any) {
    this.listChannelWithAccount = this.listChannelWithAccount.map(channel => {
      if (channel.accountId === value) {
        return {
          ...channel,
          isAliveAccount: true,
        };
      }
      return channel;
    });
  }

  get isCheckNextStep2(): boolean {
    return !(this.listChannelWithAccount.length >= 0 && this.formData?.briefingTitle) || this.validBriefingTitle === false;
  }

  get stepNames() {
    return this.stepper.stepNames;
  }

  get index() {
    return this.stepper.index;
  }

  get isFirst() {
    return this.stepper.isFirst;
  }

  get isLast() {
    return this.stepper.isLast;
  }

  beforeDestroy() {
    this.isModalOpen = false;
  }

  openModal() {
    this.isModalOpen = false;
  }

  openModalRegister() {
    this.isModalOpen = false;
    this.isOpenRegister = true;

    if (this.isShowCreateBriefing) {
      this.setIsCanShowCreateAgent(false);
    }
  }

  async openModalEnd() {
    if (this.itemSetting) {
      await this.handleSettingScrapAgent().then(r => {});
      return;
    }
    await this.handleAddScrapAgent().then(r => {});
    if (this.formData.dataSourceAccount && this.formData.dataSourceAccount.length !== 0 && this.itemCreateScrapAgent) {
      this.isModalOpen = false;
      this.isShowCreateScrapAgentEnd = true;
      return;
    }
  }

  onUpdateAgentClose() {
    console.log('close');
    this.isShowChannelSetting = false;
    this.isModalOpen = true;
    this.listChannelWithAccount.forEach(channel => {
      channel.collections.forEach(collection => {
        delete collection.isSetting;
      });
    });
    this.handleClickTabChannel();

    this.state = {
      itemChannelSetting: {
        accountChannel: null as AccountChannel | null,
        agentChannel: null as AgentChannel | null,
        bpId: null,
        datasource: [],
        channelImageUri: null,
        channelName: null,
        channelType: null,
      },
    };
  }

  async handleUpdateAgent(datasource: ChannelDatasourceProps[]) {
    this.isShowChannelSetting = false;
    this.isModalOpen = true;

    this.handleClickTabChannel();
    console.log(datasource, 'datasource');
    const payload: ScrapeBriefingRequest = {
      requestId: new Date().getTime(),
      userKey: this.$store.getters.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id,
      bpId: this.state.itemChannelSetting?.bpId,
      dataSourceAccount: [
        {
          accountId: this.state.itemChannelSetting.accountChannel?.accountId,
          channelType: this.state.itemChannelSetting?.channelType,
          isScrap: true,
          dataSources: datasource.reduce((acc, cur) => {
            if (cur.disabled) return acc;
            switch (cur.type) {
              case 'DATA_TYPE': {
                acc.push(
                  ...cur.value.map(type => {
                    const datasourceItem = this.state.itemChannelSetting.agentChannel?.datasourceList?.find(
                      el => el.dataSourceType === type
                    );
                    return {
                      agentId: datasourceItem ? datasourceItem.agentId : undefined,
                      dataSourceId: datasourceItem ? datasourceItem.dataSourceId : undefined,
                      dataSourceTypes: [type],
                      dataSourceType: type,
                      value: null,
                      dataSourceAccStatus: 1,
                      descriptionEn: this.$t(`scrap-agent.dataType.${type}`),
                    };
                  })
                );
                return acc;
              }
              case 'TRENDING':
              case 'MY_SUBSCRIPTION':
              case 'MY_CHANNEL':
              case 'INBOX':
              case 'EVERY_THING':
              case 'MY_PROFILE':
              case 'NEW_FEED': {
                if (cur.value) {
                  acc.push({
                    dataSourceTypes: [cur.type],
                    dataSourceType: cur.type,
                    value: null,
                    dataSourceAccStatus: 1,
                    descriptionEn: this.$t(`scrap-agent.dataType.${cur.type}`),
                    dataSourceId: cur.dataSourceId,
                    agentId: cur.agentId || null,
                  });
                }
                return acc;
              }
              case 'PROFILE':
              case 'KEYWORD':
              case 'URL':
              case 'TOPIC': {
                const filteredValue = cur.value.filter((el: string) => el.trim() !== '');
                console.log(filteredValue, 'cur');

                if (!isEmptyArray(cur.value) && filteredValue.length !== 0) {
                  acc.push({
                    dataSourceTypes: [cur.type],
                    dataSourceType: cur.type,
                    dataSourceAccStatus: 1,
                    descriptionEn: this.$t(`scrap-agent.dataType.${cur.type}`),
                    value: filteredValue,
                    dataSourceId: cur.dataSourceId,
                    agentId: cur.agentId || null,
                  });
                }
                return acc;
              }
            }
          }, []),
        },
      ],
    };
    console.log(payload, 'payload setting');

    const datasourceListUpdate = payload.dataSourceAccount[0].dataSources as ChannelDataSource[];
    this.listChannelWithAccount.forEach(channel => {
      channel.collections = channel.collections.map(collection => {
        if (collection.isSetting) {
          const updatedCollection: AgentChannel = {
            bpId: collection.bpId,
            bpName: collection.bpName,
            isScrap: collection.isScrap,
            datasourceList: datasourceListUpdate,
          };
          return updatedCollection;
        }
        return collection;
      });
    });

    if (payload.bpId != null) {
      await this.scrapAgentService()
        .updateScrapAgent(payload)
        .then(res => {
          console.log(res);
        });
      this.dataSourceSetting = this.listChannelWithAccount
        .filter(a => a.collections?.some(c => c.bpId === payload.bpId))
        .map(a => ({
          ...a,
          collections: a.collections.filter(c => c.bpId === payload.bpId),
        }));
    }
    // await this.handleGetListChannelWithAccount();
  }

  closeModalStep3() {
    this.isShowCreateScrapAgentEnd = false;
    this.itemCreateScrapAgent = null;
    this.$emit('isModalOpenScrap', this.isModalOpen);
  }

  async modalStep3Back(isLoading?: boolean) {
    this.isShowCreateScrapAgentEnd = false;
    this.itemCreateScrapAgent = null;
    this.isModalOpen = true;

    this.handleClickTabChannel();

    if (isLoading) {
      this.formData.briefingTitle = '';
      this.listChannel = [];
      this.listChannelWithAccount = [];
      await this.handleGetListChannel().then(r => {});
      await this.handleGetListChannelWithAccount().then(r => {});
    }
  }

  briefingPrivacy(value: any) {
    this.formData.briefingPrivacy = value.briefingPrivacy;
    this.itemSetting.privacy = value.briefingPrivacy;
    console.log(this.itemSetting, 'this.itemSetting');
  }

  handleAccessDeleteScrap(isLoading?: boolean) {
    console.log(this.itemDelete, 'this.itemDelete');
    if (isLoading) {
      let deleted = false;
      const deleteAccountId = this.itemDelete.accountId;
      const deleteChannelType = this.itemDelete.channelType;
      const deleteCollections = this.itemDelete.collections || [];
      this.listChannelWithAccount.forEach((channel, channelIndex) => {
        if (channel.accountId !== deleteAccountId || channel.channelType !== deleteChannelType) {
          return;
        }

        channel.collections = channel.collections.filter(collection => {
          const deleteBpId = deleteCollections[0]?.bpId;
          if (deleted) return true;
          if (deleteBpId && collection.bpId === deleteBpId) {
            return false;
          } else if (collection.bpId !== deleteBpId) {
            return true;
          } else if (deleteBpId == null && collection.bpId == null) {
            const sizeMatch = collection.datasourceList.length === deleteCollections[0].datasourceList.length;
            const matchFound = collection.datasourceList.some(ds => {
              const dsValue = ds.value;
              return deleteCollections[0]?.datasourceList?.some(deleteDs => {
                const typeMatched = deleteDs.dataSourceTypes?.some(type => ds.dataSourceTypes?.includes(type));

                const valueMatched =
                  (deleteDs.value === null && dsValue === null) || JSON.stringify(deleteDs.value || '') === JSON.stringify(dsValue || '');

                return typeMatched && valueMatched && sizeMatch;
              });
            });
            if (matchFound) {
              deleted = true;
              return false;
            }
            return true;
          }
        });
      });
      this.listChannelWithAccount = this.listChannelWithAccount.filter(channel => channel.collections.length > 0);
    } else {
      this.isShowAccessComponent = false;
    }
    this.isShowAccessComponent = false;
    this.itemDelete = null;
  }

  deleteScrapAgent(item: any) {
    this.isShowAccessComponent = true;
    this.itemDelete = item;
  }

  goToNext() {
    this.stepper.goToNext();
  }

  goToPrevious() {
    this.stepper.goToPrevious();
  }

  goToStep(step: string) {
    if ((this.index.value === 0 || this.index.value === 1) && step === this.stepNames.value[2]) return;
    if (this.index.value === 2 && (step === this.stepNames.value[0] || step === this.stepNames.value[1])) return;
    this.stepper.goTo(step as any);
  }

  handleShowAgent(payload: boolean) {
    this.setIsCanShowCreateAgent(true);
    this.isModalOpen = payload;
    this.isOpenRegister = false;
    this.stepper.at(1);
    this.handleClickTabChannel();
  }

  handleClickTabChannel() {
    setTimeout(() => {
      const button = document.getElementById('listChannelButton');

      if (button) {
        button.click();
      }
    }, 200);
  }

  async handleCloseLogin(data: any) {
    this.accountNameUpdateModalLogin = null;
    if (this.channelConnect?.accounts.length !== 0) {
      this.isShowStep2Login = false;
      this.isShowModalStep2Account = true;
    } else {
      this.isShowStep2Login = false;
      this.isOpenRegister = true;
    }
  }

  async handleCloseLoginAccountSetting() {
    this.isShowStep2Login = false;
    this.accountNameSettingModalLogin = null;
  }

  handleCloseFaceBookLogin(id?: string) {
    if (id) this.highLightAccount = id;
    this.handleGetListChannel().then(r => {});
    if (this.channelConnect.accounts.length !== 0 || !!id) {
      this.isShowFacebookLogin = false;
      this.isShowModalStep2Account = true;
      this.isOpenRegister = false;
    } else {
      this.isShowFacebookLogin = false;
      this.isOpenRegister = true;
    }
  }

  async handleCloseMetaSearchModal() {
    console.log(`modal Meta Search closed`);
    this.isShowScrapAgentMetaSearch = false;
    this.isOpenRegister = true;
  }

  async handleShowStep2AccountBeforeConnectNotAccount(data: any, data2: any) {
    console.log(data, 'payload to add account');
    const formData = {
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
      chanelName: data.channelType || '',
      accountName: data2.accountName || '',
      avatar: data2.avatar || '',
      password: data2.password || '',
      authorizationCode: data2.authorizationCode || null,
    };
    this.accountNameUpdateModalLogin = null;
    try {
      const res = await this.handleCreateUserAccount(formData);
      if (res) {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messSuccess')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.success')}`,
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
        await this.handleGetListChannel();
      }
    } catch (error) {
      console.log(error, 'error');
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.add-account.error')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
    if (this.accountNameSettingModalLogin && this.accountNameSettingModalLogin.trim() !== '') {
      await this.handleCloseLoginAccountSetting();
      await this.handleGetListChannelWithAccount();
      return;
    }

    if (this.isCheckCreateAccount) {
      this.isShowStep2Login = false;
      this.isShowModalStep2Account = true;
    }
  }

  async openModalStep2Account() {
    this.isShowStep2Login = false;
    this.isShowModalStep2Account = true;
  }

  async handleShowStep2AccountBeforeConnectHasAccount(data: any) {
    try {
      console.log(this.channelConnect.channelType, 'before connect account');
      switch (this.channelConnect.channelType) {
        case 'GOOGLE_DRIVE':
          this.isShowAccountConnectCloudLogin = true;
          break;
        case 'DROP_BOX':
          this.isShowAccountConnectCloudLogin = true;
          break;
        case 'ONE_DRIVE':
          this.isShowAccountConnectCloudLogin = true;
          break;

        case 'FACEBOOK':
          this.isShowFacebookLogin = true;
          break;
        case 'YOUTUBE':
          this.isShowAccountConnectYoutubeLogin = true;
          break;
        case 'REDDIT':
          this.isShowRedditAccount = true;
          break;
        case 'X_TWITTER':
          this.isShowTwitterLogin = true;
          break;

        case 'GMAIL':
          this.isShowEmailLogin = true;
          this.typeEmail = 'GMAIL';
          break;

        case 'OUTLOOK':
          this.isShowEmailLogin = true;
          this.typeEmail = 'OUTLOOK';
          break;

        case 'DAUM':
          this.isShowStep2Login = true;
          this.typeEmail = 'DAUM';
          break;
        case 'NAVER':
          this.isShowStep2Login = true;
          this.typeEmail = 'NAVER';
          break;
        case 'YAHOO':
          this.isShowStep2Login = true;
          this.typeEmail = 'YAHOO';
          break;
        case 'MEDIUM':
          this.isShowAccountMediumMode = true;
          break;
        case 'BRUNCH':
          this.isShowAccountBrunchMode = true;
          break;
        case 'URL':
          this.isShowModalRegisterFormUrl = true;
          return;
        case 'RSS':
          this.isShowRegisterScrapAgentRss = true;
          return;
        case 'WORDPRESS':
          this.isShowAccountWordpressLogin = true;
          break;
        case 'MS_TOPIC':
          this.isShowScrapAgentMetaSearch = true;
          break;
        default:
          this.isShowStep2Login = true;
          break;
      }

      this.isShowModalStep2Account = false;
    } catch (error) {
      console.error('Error in handleShowStep2AccountBeforeConnectHasAccount:', error);
    }
  }

  async handleCloseStep2AccountBeforeConnectHasAccount(data: any) {
    this.isShowModalStep2Account = false;
    this.isOpenRegister = true;
  }

  invalidName() {
    if (this.itemSetting) {
      if (this.validBriefingTitle === true) {
        return !(this.formData.briefingTitle === this.itemSetting.briefingPageName);
      } else {
        return false;
      }
    } else {
      return this.validBriefingTitle === true;
    }
  }

  async handleDeleteSuccess(accountId: string) {
    this.listChannelWithAccount = this.listChannelWithAccount.map(channel => {
      if (channel.accountId === accountId) {
        return {
          ...channel,
          isAliveAccount: false,
        };
      }
      return channel;
    });
    if (this.channelConnect.accounts.length === 1) {
      this.isShowModalStep2Account = false;
      switch (this.channelConnect.channelType) {
        case 'GOOGLE_DRIVE':
        case 'DROP_BOX':
        case 'ONE_DRIVE':
          this.isShowAccountConnectCloudLogin = true;
          break;
        case 'FACEBOOK':
          this.isShowFacebookLogin = true;
          break;
        case 'YOUTUBE':
          this.isShowAccountConnectYoutubeLogin = true;
          break;
        case 'X_TWITTER':
          this.isShowTwitterLogin = true;
          break;
        case 'GMAIL':
          this.isShowEmailLogin = true;
          this.typeEmail = 'GMAIL';
          break;
        case 'OUTLOOK':
          this.isShowEmailLogin = true;
          this.typeEmail = 'OUTLOOK';
          break;
        case 'YAHOO':
          this.isShowStep2Login = true;
          this.typeEmail = 'YAHOO';
          break;
        case 'DAUM':
          this.isShowStep2Login = true;
          this.typeEmail = 'DAUM';
          break;
        case 'NAVER_BLOG':
        case 'BRUNCH':
          this.isShowStep2Login = true;
          break;
        case 'NAVER':
          this.isShowStep2Login = true;
          this.typeEmail = 'NAVER';
          break;
        case 'WORDPRESS':
          this.isShowAccountWordpressLogin = true;
          break;
        default:
          this.isShowStep2Login = true;
          break;
      }
    }
    await this.handleGetListChannel();
    await this.getListAccount();
  }

  async handleReAuthorizeSuccess(id: string) {
    this.highLightAccount = id;
    await this.getListAccount();
  }

  async handleSubmitAccount(payload: any, userInfo?: any) {
    if (userInfo) {
      this.userEdit = userInfo;
    }
    console.log(payload, 'payload');
    switch (payload.channelType as any) {
      case 'GOOGLE_DRIVE':
        this.isShowRegisterScrapAgentDrive = true;
        break;
      case 'DROP_BOX':
        this.isShowRegisterScrapAgentBoxDrive = true;
        break;
      case 'ONE_DRIVE':
        this.isShowRegisterScrapAgentOneDrive = true;
        break;

      case 'FACEBOOK':
        this.isShowFacebookAccount = true;
        break;
      case 'YOUTUBE':
        this.isShowAccountConnectYoutube = true;
        break;
      case 'REDDIT':
        this.isShowRedditAccount = true;
        break;
      case 'X_TWITTER':
        this.isShowTwitterMode = true;
        break;

      case 'GMAIL':
        this.isShowEmailAccount = true;
        this.typeEmail = 'GMAIL';
        break;

      case 'OUTLOOK':
        this.isShowEmailAccount = true;
        this.typeEmail = 'OUTLOOK';
        break;

      case 'DAUM':
        this.isShowEmailAccount = true;
        this.typeEmail = 'DAUM';
        break;
      case 'YAHOO':
        this.isShowEmailAccount = true;
        this.typeEmail = 'YAHOO';
        break;
      case 'NAVER_BLOG':
        this.isShowAccountNaverBlogMode = true;
        break;
      case 'MEDIUM':
        this.isShowAccountMediumMode = true;
        break;
      case 'URL':
        this.isShowModalRegisterFormUrl = true;
        return;
      case 'RSS':
        this.isShowRegisterScrapAgentRss = true;
        return;
      case 'BRUNCH':
        this.isShowAccountBrunchMode = true;
        break;
      case 'WORDPRESS':
        this.isShowAccountWordpressMode = true;
        break;

      case 'NAVER':
        this.isShowEmailAccount = true;
        this.typeEmail = 'NAVER';
        break;
      case 'MS_TOPIC':
        this.isShowScrapAgentMetaSearch = true;
        break;
      default:
        this.isShowStep2Login = true;
        break;
    }

    this.isShowModalStep2Account = false;
    this.accountItem = payload;
  }

  handleModalCloseStep2Access() {
    this.isShowModalStep2Access = false;
    this.isShowModalStep2Account = true;
  }

  handleAccess(value: any) {
    this.accountItem.dataSource = value;
    this.isShowModalStep2Access = false;
    this.isModalOpen = true;

    this.handleClickTabChannel();

    this.stepper.at(1);
  }

  handleShowUrlForm() {
    if (this.categoryType == 'URL') {
      this.isOpenRegister = false;
      this.isShowModalRegisterFormUrl = true;
    } else {
      this.isOpenRegister = false;
      this.isShowRegisterScrapAgentRss = true;
    }
  }

  handleCloseRss() {
    this.isShowRegisterScrapAgentRss = false;
    this.isOpenRegister = true;
    // this.isOpenRegister = false;
    // this.isModalOpen = true;
    // this.stepper.at(1);
  }

  handleCloseUrl() {
    this.isShowModalRegisterFormUrl = false;
    this.isOpenRegister = true;
    // this.isOpenRegister = false;
    // this.isModalOpen = true;
    // this.stepper.at(1);
  }

  async addItem(value: any, value2: any) {
    this.updateChannelList(value);
    // this.listChannelWithAccount.unshift(value2);
    this.isShowModalRegisterFormUrl = false;
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    this.isShowModalStep2Account = false;
    this.isOpenRegister = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);
    // this.listChannelWithAccount = [...this.listChannelWithAccount, ...value];
    this.handleClickTabChannel();
  }

  handleCloseDrive() {
    if (this.channelConnect.accounts && this.channelConnect.accounts.length > 0) {
      this.isShowRegisterScrapAgentOneDrive = false;
      this.isShowRegisterScrapAgentBoxDrive = false;
      this.isShowRegisterScrapAgentDrive = false;
      this.isShowModalStep2Account = true;
    } else {
      this.isShowRegisterScrapAgentOneDrive = false;
      this.isShowRegisterScrapAgentBoxDrive = false;
      this.isShowRegisterScrapAgentDrive = false;
      this.isOpenRegister = true;
      this.isOpenRegister = false;
      this.isModalOpen = true;
      this.stepper.at(1);

      this.handleClickTabChannel();
    }
  }

  handleSubmitCloud() {
    this.isShowRegisterScrapAgentOneDrive = false;
    this.isShowRegisterScrapAgentBoxDrive = false;
    this.isShowRegisterScrapAgentDrive = false;
    this.isOpenRegister = true;
    this.isOpenRegister = false;
    this.isModalOpen = true;
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async handeAddRss(data) {
    // this.listChannelWithAccount.unshift(data);
    this.updateChannelList(data);
    this.isShowRegisterScrapAgentRss = false;
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    this.isShowModalStep2Account = false;
    this.isOpenRegister = false;
    this.isModalOpen = true;
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async handleAddMetaSearch(data) {
    const fromDate = data.dateRange && data.dateRange[0] ? data.dateRange[0] : '';
    const toDate = data.dateRange && data.dateRange[1] ? data.dateRange[1] : '';

    const formattedData = {
      channelId: null,
      channelName: 'Meta Search',
      channelDescription: `Search for: ${data.keyword}`,
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/metasearch.png',
      channelType: 'MS_TOPIC',
      allowAccess: 'true',
      accounts: [
        {
          accountId: null,
          accountName: '-',
          isScrap: true,
          dataSource: [
            {
              dataSourceType: 'KEYWORD',
              dataSourceTypes: ['KEYWORD'],
              value: data.keyword,
              descriptionEn: 'Keyword',
              // options: [
              //   {
              //     from: fromDate,
              //     to: toDate,
              //     limit: data.limit || 5,
              //   },
              // ],
            },
          ],
        },
      ],
    };
    // this.reorderChannelIfMatchExists(formattedData);
    // this.listChannelWithAccount.unshift(formattedData);
    await this.updateChannelList(formattedData);
    this.isShowScrapAgentMetaSearch = false;
    this.isShowModalStep2Account = false;
    this.isOpenRegister = false;
    this.isModalOpen = true;
    this.handleClickTabChannel();
  }

  handleSearchByCategory(payload: any) {
    console.log(payload);
    this.categoryType = payload;
  }

  handleChangeListStep2(value) {
    console.log(`value : `, value);
    this.formData.dataSourceAccount = this.reverseTransformData(value);
    console.log('step2 this.formData.dataSourceAccount', this.formData.dataSourceAccount);
  }

  handleOpenLoginAccount(item: any) {
    console.log(item, 'item');
    this.channelConnect = item;
    this.accountNameSettingModalLogin = item.accountName;
    this.isShowStep2Login = true;
  }

  handleReAuthorAccount(item: any) {
    this.listChannelWithAccount = this.listChannelWithAccount.map(channel => {
      if (channel.accountId === item.account_id && channel.channelType === item.channel) {
        return {
          ...channel,
          isAliveAccount: true,
        };
      }
      return channel;
    });
  }

  handleChannelSetting(value: any) {
    console.log(value, 'value common');

    const datasource = [] as ChannelDatasourceProps[];
    const datasourceTypes = CHANNEL_DATASOURCE_TYPE[value.channelType];
    datasourceTypes.forEach(datasourceType => {
      switch (datasourceType.type) {
        case 'DATA_TYPE': {
          const datasourceEverything = value.collections[0].datasourceList.find(el => el.dataSourceTypes[0] === 'EVERY_THING');
          const dataFileTypes = DATA_FILE_TYPE.map(type => type.value);
          datasource.push({
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: value.collections[0].datasourceList
              .filter(el => dataFileTypes.includes(el.dataSourceTypes[0]))
              .map(el => el.dataSourceTypes[0]),
            // agentId: value.collections[0].datasourceList.filter(el => dataFileTypes.includes(el.dataSourceType)).map(el => el.agentId),
            // dataSourceId: value.collections[0].datasourceList
            //   .filter(el => dataFileTypes.includes(el.dataSourceType))
            //   .map(el => el.dataSourceId),
            disabled: !!datasourceEverything?.dataSourceAccStatus,
          });
          break;
        }
        case 'MY_SUBSCRIPTION':
        case 'MY_CHANNEL':
        case 'MY_PROFILE': {
          if (!value.accountId || value.accountId == '') break;
          const datasourceItem = value.collections[0].datasourceList.find(el => el.dataSourceTypes[0] === datasourceType.type);
          datasource.push({
            agentId: datasourceItem ? datasourceItem.agentId : undefined,
            dataSourceId: datasourceItem ? datasourceItem.dataSourceId : undefined,
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: !!datasourceItem?.dataSourceAccStatus,
          });
          break;
        }
        case 'TRENDING':
        case 'INBOX':
        case 'EVERY_THING':
        case 'NEW_FEED': {
          const datasourceItem = value.collections[0].datasourceList.find(el => el.dataSourceTypes[0] === datasourceType.type);
          datasource.push({
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: !!datasourceItem?.dataSourceAccStatus,
            dataSourceId: datasourceItem?.dataSourceId,
            agentId: datasourceItem?.agentId || null,
          });
          break;
        }
        case 'PROFILE':
        case 'KEYWORD':
        case 'URL':
        case 'TOPIC': {
          const datasourceItem = value.collections[0].datasourceList.find(el => el.dataSourceTypes[0] === datasourceType.type);
          console.log(datasourceItem, 'datasourceItem');
          let parsedValue: string[] = [''];
          if (datasourceItem?.value) {
            if (typeof datasourceItem.value === 'string') {
              try {
                parsedValue = JSON.parse(datasourceItem.value);
              } catch (e) {
                console.warn('error parse value:', e);
                parsedValue = [''];
              }
            } else if (Array.isArray(datasourceItem.value)) {
              parsedValue = datasourceItem.value;
            }
          }
          datasource.push({
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            // value: datasourceItem ? (datasourceItem.value ? (datasourceItem.value) : ['']) : [''],
            value: parsedValue,
            dataSourceId: datasourceItem?.dataSourceId,
            agentId: datasourceItem?.agentId || null,
          });
          break;
        }
      }
    });
    console.log(datasource, 'datasource');
    this.state.itemChannelSetting.datasource = JSON.parse(JSON.stringify(datasource));
    this.state.itemChannelSetting.channelImageUri = value.channelImageUri;
    this.state.itemChannelSetting.channelName = value.channelName;
    this.state.itemChannelSetting.channelType = value.channelType;
    this.state.itemChannelSetting.agentChannel = value.collections[0];
    this.state.itemChannelSetting.accountChannel = value;
    this.state.itemChannelSetting.bpId = value.collections[0].bpId;
    this.isShowChannelSetting = true;
    this.isModalOpen = false;
  }

  handelCloseAccountConnectYoutube() {
    console.log(this.channelConnect.accounts, 'this.channelConnect.accounts');
    if (!this.channelConnect.accounts || this.channelConnect.accounts.length === 0) {
      this.isOpenRegister = true;
      this.isShowAccountConnectYoutube = false;
    } else {
      this.isShowAccountConnectYoutube = false;
      this.isShowModalStep2Account = true;
    }
  }

  handeBackConnectYoutube() {
    if (!this.channelConnect.accounts || this.channelConnect.accounts.length === 0) {
      this.isShowAccountConnectYoutubeLogin = true;
      this.isShowAccountConnectYoutube = false;
    } else {
      this.isShowAccountConnectYoutube = false;
      this.isShowModalStep2Account = true;
    }
  }

  skipBack() {
    switch (this.channelConnect.channelType) {
      case 'YOUTUBE':
        this.userEdit = {};
        this.isShowAccountConnectYoutube = true;
        this.isShowAccountConnectYoutubeLogin = false;
        this.isShowModalStep2Account = false;
        return;
      case 'X_TWITTER':
        this.userEdit = {};
        this.isShowTwitterLogin = false;
        this.isShowTwitterMode = true;
        this.isShowModalStep2Account = false;
        return;
      case 'GOOGLE_DRIVE':
        this.isShowRegisterScrapAgentDrive = true;
        this.isShowAccountConnectYoutubeLogin = false;
        this.isShowTwitterLogin = false;
        this.isShowModalStep2Account = false;
        return;
      case 'DROP_BOX':
        this.isShowRegisterScrapAgentBoxDrive = true;
        this.isShowAccountConnectYoutubeLogin = false;
        this.isShowTwitterLogin = false;
        this.isShowModalStep2Account = false;
        return;
      case 'ONE_DRIVE':
        this.isShowRegisterScrapAgentOneDrive = true;
        this.isShowAccountConnectYoutubeLogin = false;
        this.isShowTwitterLogin = false;
        this.isShowModalStep2Account = false;
        return;
    }
  }

  async addItemEmail(data: any) {
    console.log(data, 'data');
    const index = this.listChannelWithAccount.findIndex(
      item => item.accountId === data.accounts[0].accountId && item.channelType === data.channelType
    );

    if (index !== -1) {
      const account = { ...this.listChannelWithAccount[index] };
      account.collections = account.collections.filter(collection => collection.bpId !== null && collection.bpId !== undefined);
      this.$set(this.listChannelWithAccount, index, account);
    }
    this.updateChannelList(data);
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    this.isShowModalStep2Account = false;
    this.isShowConnectEmail = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async openUpdateLogin(item: any) {
    console.log(item, 'item');
    this.accountNameUpdateModalLogin = item.accountName;
    this.isShowModalStep2Account = false;
    this.isShowStep2Login = true;
  }

  async addItemFacebook(data) {
    console.log(data, 'data fb');
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    // this.listChannelWithAccount.unshift(data);
    this.updateChannelList(data);
    this.isShowFacebookAccount = false;
    this.isShowModalStep2Account = false;
    this.isModalOpen = true;
    this.isOpenRegister = false;
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  handleCloseFacebookAccount() {
    this.isShowFacebookAccount = false;
    this.isShowModalStep2Account = true;
  }

  handleBackFacebookAccount() {
    this.isShowFacebookAccount = false;
    this.isShowFacebookLogin = true;
  }

  handelCloseAccountConnectGoogleLogin(payload: boolean, id?: string) {
    if (id) {
      this.highLightAccount = id;
    }
    this.handleGetListChannel().then(r => {});
    const isNotAccount = this.channelConnect.accounts.length == 0;
    switch (this.channelConnect.channelType) {
      case 'YOUTUBE':
        this.isShowAccountConnectYoutubeLogin = false;
        if (isNotAccount && !id) {
          this.isOpenRegister = true;
          return;
        }
        this.isShowModalStep2Account = true;
        return;
      case 'X_TWITTER':
        this.isShowTwitterLogin = false;
        if (isNotAccount && !id) {
          this.isOpenRegister = true;
          return;
        }
        this.isShowModalStep2Account = true;
        return;

      case 'GOOGLE_DRIVE':
      case 'DROP_BOX':
      case 'ONE_DRIVE':
        this.isShowAccountConnectCloudLogin = false;
        if (isNotAccount && !id) {
          this.isOpenRegister = true;
          return;
        }
        this.isShowModalStep2Account = true;
        return;
    }
  }

  handelCloseEmailLogin(id?: string) {
    this.isShowEmailLogin = false;
    this.handleGetListChannel().then(r => {});
    if (id) {
      this.highLightAccount = id;
    }
    if (this.channelConnect.accounts.length !== 0 || !!id) {
      this.isShowModalStep2Account = true;
    } else {
      this.isOpenRegister = true;
    }
    // if(!payload){
    //   this.isOpenRegister = true;
    //   return;
    // }
    // this.isShowModalStep2Account = true;
  }

  // function call api_____________________________________________////////////////////...........................___________________

  async handleAddScrapAgent() {
    if (this.itemSetting && this.itemSetting.bpId) {
      this.formData = {
        ...this.formData,
        bpId: this.itemSetting.bpId,
        dataSourceAccount:
          this.formData?.dataSourceAccount
            ?.map(account => {
              const filteredDataSources = account.dataSources?.filter(ds => ds.isScrap === true) || [];
              return {
                ...account,
                isScrap: true,
                dataSources: filteredDataSources,
              };
            })
            .filter(account => account.dataSources.length > 0) || [],
      };
    } else {
      this.formData = {
        ...this.formData,
        dataSourceAccount:
          this.formData?.dataSourceAccount
            ?.map(account => {
              const filteredDataSources = account.dataSources?.filter(ds => ds.isScrap === true) || [];
              return {
                ...account,
                isScrap: true,
                dataSources: filteredDataSources,
              };
            })
            .filter(account => account.dataSources.length > 0) || [],
      };
    }
    if (!this.formData.dataSourceAccount || this.formData.dataSourceAccount.length === 0) {
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.not-select.mess')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.not-select.title')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    console.log(this.formData, 'this.formData');
    try {
      let result;
      // Check if any special channel types exist that need merging
      const hasRealtimeCrawler = this.formData?.dataSourceAccount?.some(account => account.channelType === 'REALTIME_CRAWLER');

      const hasMsTopic = this.formData?.dataSourceAccount?.some(account => account.channelType === 'MS_TOPIC');

      const hasRss = this.formData?.dataSourceAccount?.some(account => account.channelType === 'RSS');

      // If any special type exists, use the preparation function
      if (hasRealtimeCrawler || hasMsTopic || hasRss) {
        // Process the data to merge items of the same channel type
        this.itemCreateScrapAgent = this.prepareItemsForSubmissions();
        // result = await this.scrapAgentService().addScrapAgent(preparedData);
      } else {
        // No special items found, proceed normally
        this.itemCreateScrapAgent = this.formData;
        // result = await this.scrapAgentService().addScrapAgent(this.formData);
      }
    } catch (error) {
      console.error('Error adding scrap agent:', error);
    }
  }

  async handleSettingScrapAgent() {
    if (this.itemSetting && this.itemSetting.bpId) {
      this.formData = {
        ...this.formData,
        bpId: this.itemSetting.bpId,
        dataSourceAccount:
          this.formData?.dataSourceAccount
            ?.map(account => {
              const filteredDataSources = (account.dataSources || [])
                .map(ds => {
                  if (ds.isScrap === true) {
                    if (ds.bpId === this.itemSetting.bpId) {
                      return ds;
                    } else {
                      return {
                        ...ds,
                        agentId: null,
                        dataSourceId: null,
                        bpName: null,
                        bpId: null,
                      };
                    }
                  }
                  return null;
                })
                .filter(Boolean);
              return {
                ...account,
                isScrap: true,
                dataSources: filteredDataSources,
              };
            })
            .filter(account => account.dataSources.length > 0) || [],
      };
      console.log(this.formData, 'this.formData');
    }
    if (!this.formData.dataSourceAccount || this.formData.dataSourceAccount.length === 0) {
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.not-select.mess')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.not-select.title')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    console.log(this.formData, 'this.formData');
    try {
      let result;
      // Check if any special channel types exist that need merging
      const hasRealtimeCrawler = this.formData?.dataSourceAccount?.some(account => account.channelType === 'REALTIME_CRAWLER');

      const hasMsTopic = this.formData?.dataSourceAccount?.some(account => account.channelType === 'MS_TOPIC');

      const hasRss = this.formData?.dataSourceAccount?.some(account => account.channelType === 'RSS');

      // If any special type exists, use the preparation function
      if (hasRealtimeCrawler || hasMsTopic || hasRss) {
        // Process the data to merge items of the same channel type
        const preparedData = this.prepareItemsForSubmissions();
        result = await this.scrapAgentService().updateScrapAgent(preparedData);
      } else {
        // No special items found, proceed normally
        // this.itemCreateScrapAgent = this.formData;
        result = await this.scrapAgentService().updateScrapAgent(this.formData);
      }
      console.log(result, 'result');
      if (result) {
        this.itemSetting.briefingPageName = this.formData.briefingTitle;
        this.isModalOpen = false;
      }
      // this.$bvToast.toast(`${this.$t('scrap-agent.toast.update-scrap.messSuccess')}`, {
      //   toaster: 'b-toaster-bottom-right',
      //   title: `${this.$t('scrap-agent.toast.success')}`,
      //   variant: 'success',
      //   solid: true,
      //   autoHideDelay: 5000,
      // });
      this.$emit('updateScrapAgentSuccess');
      // await this.handleGetListChannelWithAccount();
    } catch (error) {
      console.error('Error setting scrap agent:', error);
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.update-scrap.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.error')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }

  async handleConnectChannelScrapAgent(data) {
    this.channelConnect = data;
    console.log(data, 'data pick');
    await this.getListAccount();
    if (data?.accounts && data.accounts.length > 0) {
      this.isOpenRegister = false;
      this.isShowModalStep2Account = true;
    } else {
      this.isOpenRegister = false;
      switch (data.channelType) {
        case 'YOUTUBE':
          this.isShowAccountConnectYoutubeLogin = true;
          return;
        case 'X_TWITTER':
          this.isShowTwitterLogin = true;
          return;
        case 'GMAIL':
          this.isShowEmailLogin = true;
          this.typeEmail = 'GMAIL';
          return;
        case 'OUTLOOK':
          this.isShowEmailLogin = true;
          this.typeEmail = 'OUTLOOK';
          return;
        case 'YAHOO':
          this.isShowStep2Login = true;
          this.typeEmail = 'YAHOO';
          return;
        case 'MEDIUM':
          this.isShowAccountMediumMode = true;
          return;
        case 'BRUNCH':
          this.isShowAccountBrunchMode = true;
          return;
        case 'URL':
          this.isShowModalRegisterFormUrl = true;
          return;
        case 'RSS':
          this.isShowRegisterScrapAgentRss = true;
          return;
        case 'WORDPRESS':
          this.isShowAccountWordpressLogin = true;
          return;
        case 'GOOGLE_DRIVE':
          this.isShowAccountConnectCloudLogin = true;
          return;
        case 'ONE_DRIVE':
          this.isShowAccountConnectCloudLogin = true;
          return;
        case 'DROP_BOX':
          this.isShowAccountConnectCloudLogin = true;
          return;
        case 'MS_TOPIC':
          this.isShowScrapAgentMetaSearch = true;
          return;
        case 'FACEBOOK':
          this.isShowFacebookLogin = true;
          return;
        default:
          console.warn('Unknown channel type:', data.channelType);
      }
      this.isShowStep2Login = true;
    }
  }

  async handleCreateUserAccount(data: any) {
    try {
      this.isCheckCreateAccount = false;
      const result = await this.scrapAgentService().addUserAccount(data);
      console.log(result);
      if (result?.status == 200) {
        const responseBody = result?.data?.body?.body?.body;
        if (responseBody) {
          this.highLightAccount = responseBody.accountId;
          this.listChannelWithAccount = this.listChannelWithAccount.map(channel => {
            if (channel.accountId === responseBody.accountId) {
              return {
                ...channel,
                isAliveAccount: true,
              };
            }
            return channel;
          });
        }
        return (this.isCheckCreateAccount = true);
      }
      return (this.isCheckCreateAccount = false);
    } catch (error) {
      this.isCheckCreateAccount = false;
      console.error('Error fetching ScrapAgent data:', error);
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.add-account.titleAuFail')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }

  updateChannelList(payload: any) {
    console.log(payload, 'payload');
    if (this.sourceCacheList.length === 0) {
      this.sourceCacheList.unshift(payload);
    } else {
      const index = this.sourceCacheList.findIndex(
        item => item.channelType === payload.channelType && item.accounts?.[0]?.accountId === payload.accounts?.[0]?.accountId
      );

      if (index !== -1) {
        this.sourceCacheList.splice(index, 1);
      }
      this.sourceCacheList.unshift(payload);
    }

    const index = this.listChannelWithAccount.findIndex(ch => {
      const accIdCh = ch.accountId ?? '';
      const accIdPayload = payload.accounts?.[0]?.accountId ?? '';
      return ch.channelType === payload.channelType && accIdCh === accIdPayload;
    });

    if (index !== -1) {
      const matched = this.listChannelWithAccount[index];
      matched.collections = matched.collections.map(col => ({
        ...col,
        isScrap: false,
      }));
      matched.collections = matched.collections.filter(col => col.bpId != null);

      matched.collections.unshift({
        isScrap: true,
        datasourceList: payload.accounts[0].dataSource || [],
      });

      if (index > 0) {
        this.listChannelWithAccount.splice(index, 1);
        this.listChannelWithAccount.unshift(matched);
      }
    } else {
      const item = {
        fullname: payload.accounts[0].fullname || payload.accounts[0].fullName,
        accountId: payload.accounts[0].accountId,
        accountName: payload.accounts[0].accountName,
        channelType: payload.channelType,
        channelNameEn: payload.channelName,
        channelImageUri: payload.channelImageUri,
        isAliveAccount: true,
        collections: [
          {
            bpId: null,
            bpName: null,
            isScrap: payload.accounts[0].isScrap || false,
            datasourceList: payload.accounts[0].dataSource,
          },
        ],
      };
      this.listChannelWithAccount.unshift(item);
    }
  }
  async handleSettingDataSource(item: any) {
    const payload: ScrapeBriefingRequest = {
      requestId: new Date().getTime(),
      userKey: this.$store.getters.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id,
      bpId: this.itemSetting.bpId,
      dataSourceAccount: [
        {
          accountId: item.accounts[0].accountId,
          channelType: item.channelType,
          isScrap: true,
          dataSources: item.accounts[0].dataSource,
        },
      ],
    };
    if (payload.bpId != null) {
      await this.scrapAgentService()
        .updateScrapAgent(payload)
        .then(res => {
          console.log(res);
        });
      const datasourceListUpdate = payload.dataSourceAccount[0].dataSources as ChannelDataSource[];
      this.listChannelWithAccount.forEach(channel => {
        if (channel.channelType === item.channelType && channel.accountId === item.accounts[0].accountId) {
          channel.collections = channel.collections.map(collection => {
            if (collection.bpId === this.itemSetting.bpId) {
              return {
                ...collection,
                datasourceList: datasourceListUpdate,
              };
            }
            return collection;
          });
        }
      });
      // await this.handleGetListChannelWithAccount();
      this.dataSourceSetting = this.listChannelWithAccount
        .filter(a => a.collections?.some(c => c.bpId === payload.bpId))
        .map(a => ({
          ...a,
          collections: a.collections.filter(c => c.bpId === payload.bpId),
        }));
    }
  }

  addItemGoogleDrive(data, value?: boolean) {
    if (value) {
      this.handleSettingDataSource(data).then(r => {});
    } else {
      this.updateChannelList(data);
    }
    // this.listChannelWithAccount.unshift(data);
    this.isShowRegisterScrapAgentDrive = false;
    this.isShowAccountConnectYoutube = false;
    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async addItemYoutube(data, value?: boolean) {
    if (value) {
      this.handleSettingDataSource(data).then(r => {});
    } else {
      this.updateChannelList(data);
    }
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    // this.listChannelWithAccount.unshift(data);
    this.isShowAccountConnectYoutube = false;
    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async addItemTwitter(data, value?: boolean) {
    if (value) {
      this.handleSettingDataSource(data).then(r => {});
    } else {
      this.updateChannelList(data);
    }
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    // this.listChannelWithAccount.unshift(data);
    this.isShowTwitterMode = false;
    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async addItemWordpress(data, value?: boolean) {
    if (value) {
      this.handleSettingDataSource(data).then(r => {});
    } else {
      this.updateChannelList(data);
    }
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    this.isShowAccountWordpressMode = false;
    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }
  async addItemNaverBlog(data, value?: boolean) {
    if (value) {
      this.handleSettingDataSource(data).then(r => {});
    } else {
      this.updateChannelList(data);
    }
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    this.isShowAccountNaverBlogMode = false;
    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async addItemBlog(data) {
    await this.handleCloseStep2AccountBeforeConnectHasAccount;
    // this.listChannelWithAccount.unshift(data);
    this.updateChannelList(data);
    this.isShowAccountNaverBlogMode = false;
    this.isShowAccountBrunchMode = false;
    this.isShowAccountMediumMode = false;
    this.isShowAccountWordpressMode = false;

    this.isShowModalStep2Account = false;
    (this.isModalOpen = true), (this.isOpenRegister = false);
    this.stepper.at(1);

    this.handleClickTabChannel();
  }

  async handelCloseBlog(id?: string) {
    if (id) {
      this.highLightAccount = id;
    }
    this.isShowAccountNaverBlogMode = false;
    this.isShowAccountWordpressMode = false;
    this.isShowAccountWordpressLogin = false;
    this.isShowAccountMediumMode = false;
    this.isShowAccountBrunchMode = false;
    this.isShowModalStep2Account = true;
  }

  async handelCloseBrunch() {
    this.isShowAccountBrunchMode = false;
    this.isOpenRegister = true;
  }

  async handelCloseMedium() {
    this.isShowAccountMediumMode = false;
    this.isOpenRegister = true;
  }

  async handelCloseWordpress(id?: string) {
    if (id) {
      this.highLightAccount = id;
    }
    this.handleGetListChannel().then(r => {});
    if (this.channelConnect.accounts.length !== 0 || !!id) {
      this.isShowAccountWordpressLogin = false;
      this.isShowModalStep2Account = true;
      this.isOpenRegister = false;
    } else {
      this.isShowAccountWordpressLogin = false;
      this.isOpenRegister = true;
    }
  }

  async handelCloseTwitter(value: boolean, id?: string) {
    if (id) {
      this.highLightAccount = id;
    }
    this.handleGetListChannel().then(r => {});
    this.isShowTwitterMode = false;
    this.isShowTwitterLogin = false;

    if ((this.channelConnect.accounts && this.channelConnect.accounts.length > 0) || !!id) {
      this.isShowModalStep2Account = true;
    } else {
      this.isOpenRegister = true;
    }
  }

  async userData(data) {
    const payload: Account = {
      accountName: data.channelTitle,
      authorizationCode: data.access_token,
      appId: null,
      chanelName: this.channelConnect.channelType,
      password: '',
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
    };
    await this.handleCreateUserAccount(payload);
  }

  async userDataCloud(data: any) {
    this.isCheckCreateAccount = false;
    const result = await this.scrapAgentService().addUserAccount(data);
    console.log(result);
    if (result?.status == 200) {
      return (this.isCheckCreateAccount = true);
    }
    return (this.isCheckCreateAccount = false);
  }

  prepareItemsForSubmissions() {
    // Create a deep copy to avoid modifying the original
    const formDataCopy = JSON.parse(JSON.stringify(this.formData));

    if (!formDataCopy.dataSourceAccount || !Array.isArray(formDataCopy.dataSourceAccount)) {
      return formDataCopy;
    }

    // Define channel types that need special merging
    const channelTypesToMerge = ['REALTIME_CRAWLER', 'MS_TOPIC', 'RSS'];

    // Process each channel type
    channelTypesToMerge.forEach(channelType => {
      this.mergeItemsByChannelType(formDataCopy, channelType);
    });

    return formDataCopy;
  }

  mergeItemsByChannelType(data, channelType) {
    // Find all items of this channel type
    const itemsToMerge = data.dataSourceAccount.filter(item => item.channelType === channelType);

    // Only merge if multiple items found
    if (itemsToMerge.length > 1) {
      // Collect all dataSources from all items of this type
      const allDataSources = itemsToMerge.flatMap(item => item.dataSources || []);

      // Create a merged item
      const mergedItem = {
        channelType: channelType,
        accountId: null,
        isScrap: true,
        dataSources: allDataSources,
      };

      // Remove all original items of this type
      data.dataSourceAccount = data.dataSourceAccount.filter(item => item.channelType !== channelType);

      // Add the merged item to the beginning
      data.dataSourceAccount.unshift(mergedItem);
    }
  }

  async handleGetListChannel() {
    this.listChannel = [];
    try {
      const data = {
        requestId: new Date().getTime().toString(),
        userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
        chanelName: null,
      };
      const result = await this.scrapAgentService().getListChannelConnectAccount(this.categoryType);
      const rawChannels = result?.data?.body?.body ?? [];
      const res = await this.scrapAgentService().getUserScrapAgent(data);
      const userAccounts = res?.data?.body ?? [];

      this.listChannel = rawChannels.map((channel: Channel) => {
        const accounts = userAccounts.filter(account => account.chanelName === channel.channelType);
        return {
          ...channel,
          accounts,
          numberRegister: accounts.length,
        };
      });

      console.log(this.listChannel, '<<< Final listChannel');
    } catch (error) {
      console.error('Error fetching ScrapAgent data:', error);
      this.listChannel = [];
    }
  }

  reverseTransformData(input) {
    if (!Array.isArray(input)) {
      console.error('reverseTransformData error: input is not an array', input);
      return [];
    }

    return input.map(item => ({
      channelType: item.channelType,
      channelName: item.channelNameEn || item.channelName,
      accountId: item.accountId ?? null,
      // isScrap: item.accounts && item.accounts.length > 0 ? item.accounts[0].isScrap ?? false : false,
      dataSources: Array.isArray(item.collections)
        ? item.collections.flatMap(collection =>
            (collection.datasourceList || []).map(ds => ({
              ...ds,
              isScrap: collection.isScrap,
              bpName: collection.bpName,
              bpId: collection.bpId,
            }))
          )
        : [],
    }));
  }

  transformData(input, bpId?: string) {
    if (!bpId) return input;

    const matchedChannels: any[] = [];
    const unmatchedChannels: any[] = [];

    for (const channel of input) {
      const newCollections = [...(channel.collections || [])];
      const matchedIndex = newCollections.findIndex(col => col.bpId === bpId);

      if (matchedIndex !== -1) {
        newCollections[matchedIndex] = {
          ...newCollections[matchedIndex],
          isScrap: true,
        };

        if (matchedIndex > 0) {
          const [matchedCol] = newCollections.splice(matchedIndex, 1);
          newCollections.unshift(matchedCol);
        }

        matchedChannels.push({
          ...channel,
          collections: newCollections,
        });
      } else {
        unmatchedChannels.push(channel);
      }
    }

    return [...matchedChannels, ...unmatchedChannels];
  }

  async handleGetListChannelWithAccount() {
    this.listChannelWithAccount = [];
    this.loadingRegisterChannel = true;
    if (this.itemSetting && this.itemSetting.briefingPageName) {
      this.formData.briefingTitle = this.itemSetting.briefingPageName;
    }
    try {
      const userId = JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null;
      const result = await this.scrapAgentService().getAllChannelByChannel(userId, null, 0, 100000);
      this.listChannelWithAccount = result?.data?.body.data;
      this.listChannelWithAccount.forEach(channel => {
        channel.collections?.forEach(collection => {
          if (collection.isScrap === true) {
            collection.isScrap = false;
          }
        });
      });
      // const data = {
      //   requestId: new Date().getTime().toString(),
      //   userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
      //   chanelName: this.channelConnect.channelType,
      // };
      // const result1 = await this.scrapAgentService().getUserScrapAgent(data);
      if (this.itemSetting && this.itemSetting.bpId) {
        this.listChannelWithAccount = await this.transformData(this.listChannelWithAccount, this.itemSetting.bpId);
        this.dataSourceSetting = this.listChannelWithAccount
          .filter(a => a.collections?.some(c => c.bpId === this.itemSetting.bpId))
          .map(a => ({
            ...a,
            collections: a.collections.filter(c => c.bpId === this.itemSetting.bpId),
          }));
        // } else {
        //   this.listChannelWithAccount = await this.transformData(this.listChannelWithAccount);
      }
    } catch (error) {
      console.error('Error fetching ScrapAgent data:', error);
      this.listChannelWithAccount = [];
    } finally {
      this.loadingRegisterChannel = false;
    }
  }

  get modalStates() {
    return {
      isShowModalStep2Account: this.isShowModalStep2Account,
      isShowEmailLogin: this.isShowEmailLogin,
      isShowAccountConnectYoutubeLogin: this.isShowAccountConnectYoutubeLogin,
      isShowTwitterLogin: this.isShowTwitterLogin,
    };
  }

  // Watch computed property
  @Watch('modalStates', { deep: true })
  async getListAccount() {
    try {
      const data = {
        requestId: new Date().getTime().toString(),
        userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
        chanelName: this.channelConnect.channelType,
      };
      const result = await this.scrapAgentService().getUserScrapAgent(data);
      this.listChannel = this.listChannel.map(m => {
        if (m.chanelName === this.channelConnect.channelType) {
          return { ...m, accounts: result.data?.body };
        }
        return m;
      });

      console.log(this.listChannel, 'this.listChannel');
      this.channelConnect.accounts = result?.data?.body.map(item => ({
        accountId: item.accountId.toString(),
        accountName: item.accountName || '',
        isScrap: true,
        avatar: item.avatar,
        isTokenAlive: item.isTokenAlive,
        isTokenStatus: item.isTokenStatus,
        isAppAlive: item.isAppAlive,
        fullName: item.fullName || '',
      }));
      if (this.highLightAccount !== '') {
        this.channelConnect.accounts = this.channelConnect.accounts.sort((a, b) => {
          return a.accountId === this.highLightAccount ? -1 : b.accountId === this.highLightAccount ? 1 : 0;
        });
      }
      this.channelConnect.numberRegister = this.channelConnect.accounts.length;
      console.log(this.channelConnect, 'this.channelConnect.accounts');
    } catch (error) {
      console.error('Error fetching ScrapAgent data:', error);
    }
  }

  // watch function-------------------------------------------------------.......................................---------

  async mounted() {
    this.listChannel = [];
    this.listChannelWithAccount = [];
    const userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id;
    const lang = this.$store.getters.currentLanguage;
    try {
      const res = await this.briefingService().callAPIGetScrapAgents(userKey, null, 0, 10000, true, lang);
      const briefingList = res.data?.body?.body?.briefingPageList;
      this.scrapAgentDataList = [...res.data?.body?.body?.briefingPageList];
      this.listAgent = briefingList.map((item: any) => item.briefingPageName);
      this.isLoadingGetScrapAgentDataList = false;
    } catch (e) {
      console.log('error', e);
      this.isLoadingGetScrapAgentDataList = false;
    }
    await this.handleGetListChannel().then(r => {});
    await this.handleGetListChannelWithAccount().then(r => {});
  }

  @Watch('isOpenRegister')
  onIsOpenRegisterChanged(value: boolean) {
    if (value) {
      console.log('..', this.formData);
    }
  }

  @Watch('categoryType')
  onIsChangeCategory(value: boolean) {
    this.handleGetListChannel().then(r => {});
  }

  @Watch('isModalOpen')
  onIsModalOpenChanged(value: boolean) {
    if (
      !this.isOpenRegister &&
      !this.isShowModalStep2Account &&
      !this.isShowModalStep2Access &&
      !this.isShowRegisterScrapAgentRss &&
      !this.isShowModalRegisterFormUrl &&
      !this.isShowRegisterScrapAgentOneDrive &&
      !this.isShowRegisterScrapAgentBoxDrive &&
      !this.isShowRegisterScrapAgentDrive &&
      !this.isShowCreateScrapAgentEnd &&
      !this.isShowChannelSetting &&
      !this.isShowScrapAgentMetaSearch
    ) {
      this.$emit('isModalOpenScrap', this.isModalOpen);
    }

    // this.handleGetListChannel().then();
    if (this.isModalOpen) {
      this.setIsCanShowCreateAgent(true);
    }
  }

  close() {
    this.isModalOpen = false;
    this.setIsCanShowCreateAgent(true);
  }

  emitClose() {
    if (!this.isShowCreateBriefing) {
      this.$emit('modal:close');
    } else {
      this.close();
    }
  }

  clickScrap(isForAll, data) {
    if (isForAll) {
      if (this.connectScrapAgentList?.length && this.connectScrapAgentList?.length === this.scrapAgentDataList?.length) {
        this.connectScrapAgentList = [];
      } else {
        this.connectScrapAgentList = this.scrapAgentDataList.map(item => item.bpId);
      }
    } else {
      if (this.connectScrapAgentList.includes(data)) {
        const index = this.connectScrapAgentList.indexOf(data);

        if (index > -1) {
          this.connectScrapAgentList.splice(index, 1);
        }
      } else {
        this.connectScrapAgentList.push(data);
      }
    }

    this.handleConnectScrapAgentList();
  }

  filteredAndSortedItems(arr) {
    try {
      //sort report and discovery
      const temp = arr
        .filter(item => ['report', 'discovery'].includes(item?.documentType?.toLowerCase()))
        .sort((a, b) => {
          const aType = a.documentType.toLowerCase();
          const bType = b.documentType.toLowerCase();
          if (aType === 'report' && bType !== 'report') return -1;
          if (aType !== 'report' && bType === 'report') return 1;
          return 0;
        })
        .slice(0, 2);
      if (temp?.length > 0) {
        return temp;
      } else {
        return arr.slice(0, 2) || [];
      }
    } catch (err) {
      return arr;
    }
  }

  onImageError(event) {
    event.target.style.position = 'relative';
    event.target.style.left = '0px';
    event.target.style.top = '0px';
    event.target.style.objectFit = 'cover';
    event.target.src = 'content/images/images_v3/common/go-empty-thumb-sz288.png';
  }

  handleConnectScrapAgentList() {
    this.$emit('handleConnectScrapAgentList', this.connectScrapAgentList || []);
  }

  markDoneCreateScrapAgent() {
    this.$emit('markDoneCreateScrapAgent');
  }
}
